import { render, staticRenderFns } from "./ClicList.vue?vue&type=template&id=3be3cf19&"
import script from "./ClicList.vue?vue&type=script&lang=js&"
export * from "./ClicList.vue?vue&type=script&lang=js&"
import style0 from "./ClicList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports